/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `MODERATOR` - Moderator
* `SUPERMODERATOR` - Super Moderator
 */
export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoleEnum = {
  MODERATOR: 'MODERATOR',
  SUPERMODERATOR: 'SUPERMODERATOR',
} as const;
